.nav {
  min-inline-size: 0;
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  align-items: center;
  font-size: var(--text-sm);
}

.item {
  display: inline-flex;
  gap: var(--space-1);
  align-items: center;
  min-inline-size: 0;
}

.link {
  color: var(--color-text-muted);
  text-decoration: none;
}

.link:hover {
  color: var(--color-text);
  text-decoration: underline;
}

.current {
  color: var(--color-text);
  font-weight: var(--weight-medium);
}

.separator {
  display: inline-flex;
  color: var(--color-text-subtle);
}
